import React, { useState } from 'react';
import {
  Box,
  Typography,
  Paper,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

interface PayloadViewerProps {
  payload: Record<string, unknown> | null;
}

const PayloadViewer: React.FC<PayloadViewerProps> = ({ payload }) => {
  const [expanded, setExpanded] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (!payload) return;
    navigator.clipboard.writeText(JSON.stringify(payload, null, 2));
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  if (!payload || Object.keys(payload).length === 0) {
    return (
      <Box>
        <Typography variant="h6" gutterBottom>
          Raw Payload
        </Typography>
        <Paper variant="outlined" sx={{ p: 2, color: 'text.secondary' }}>
          No payload
        </Paper>
      </Box>
    );
  }

  const jsonStr = JSON.stringify(payload, null, 2);

  return (
    <Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        sx={{ mb: 1 }}
      >
        <Typography variant="h6">Raw Payload</Typography>
        <Box>
          <IconButton size="small" onClick={handleCopy} title="Copy">
            <ContentCopyIcon fontSize="small" />
          </IconButton>
          <IconButton
            size="small"
            onClick={() => setExpanded(!expanded)}
            title={expanded ? 'Collapse' : 'Expand'}
          >
            {expanded ? (
              <ExpandLessIcon fontSize="small" />
            ) : (
              <ExpandMoreIcon fontSize="small" />
            )}
          </IconButton>
        </Box>
      </Box>
      <Paper
        variant="outlined"
        sx={{
          p: 2,
          fontFamily: 'monospace',
          fontSize: '0.8rem',
          maxHeight: expanded ? 'none' : 200,
          overflow: 'auto',
          bgcolor: '#1e1e1e',
          color: '#d4d4d4',
        }}
      >
        <pre style={{ margin: 0, whiteSpace: 'pre-wrap' }}>{jsonStr}</pre>
      </Paper>
      {copied && (
        <Typography variant="caption" color="success.main" sx={{ ml: 1 }}>
          Copied!
        </Typography>
      )}
    </Box>
  );
};

export default PayloadViewer;
